<template>
  <div>
    <el-dialog title="上门设计费用项" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
               style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose" v-el-drag-dialog
               v-el-dialog-center>

      <!-- 品牌信息 -->
      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>设计费用</b>
            </div>
            <table class="table-detail">
              <tbody>

              <tr>


                <th>
                  <em class="f-red">*</em>
                  序号
                </th>
                <td>
                  <el-input size="medium" :maxlength="50" v-model="formData.seq" placeholder="名称" />
                </td>
                <th>
                  <em class="f-red">*</em>
                  费用名称
                </th>
                <td>
                  <el-input size="medium" :maxlength="200" v-model="formData.feeName" placeholder="名称" />
                </td>
              </tr>
              </tbody>
            </table>
          </div>


        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain class="button-sty" @click="dialogClose">
          <i class="el-icon-close el-icon"></i>
          取 消
        </el-button>
        <el-button type="primary" @click="commitData" class="button-sty">
          <i class="el-icon-check el-icon"></i>
          确 定
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import orderDialog from '@/views/dialogCommon/radioOrderDialog.vue';
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'starLevelObj'],
  mixins: [selectDialogMixins],
  components: { preconditionDialog, pager, orderDialog },

  created() {
    this.initSetting()
    if (this.starLevelObj != null) {
      this.formData = this.starLevelObj
      if (!this.formData.isNew) {
        this.formData.isNew = false
      }
    }
  },

  watch: {},

  mounted() {
    /*this.loadDictData()*/
  },

  computed: {},

  data() {
    return {
      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      area: {
        country: null,
        province: null,
        city: null,
        county: null,
        town: null,
      },
      areaOption: [],

      dataId: 0,


      formData: {
        seq: 1,
        feeName: null,
      },
      showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      addressTypeOption: [],

    };
  },


  methods: {

    // 当前页面确认按钮逻辑
    commitData() {
      if (this.formData.seq == null || this.formData.seq === '') {
        this.$message.warning('序号不能为空')
        return
      }
      if (this.formData.feeName == null || this.formData.feeName === '') {
        this.$message.warning('费用名称不能为空')
        return
      }

      // console.log('地址弹框数据: ', this.formData)
      this.$emit('commitData', this.formData)
      this.dialogClose()
    },

    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.area.country = areaNode[0].label;
          this.area.province = null;
          this.area.city = null;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 2) {
          this.area.province = areaNode[0].label;
          this.area.city = null;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 3) {
          this.area.city = areaNode[0].label;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 4) {
          this.area.county = areaNode[0].label;
          this.area.town = null;
        } else if (areaNode[0].level == 5) {
          this.area.town = areaNode[0].label;
        }

      } else {
        this.formData.areaId = null
        this.area.country = null;
        this.area.province = null;
        this.area.city = null;
        this.area.county = null;
        this.area.town = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

// ::v-deep .el-dialog {
//     margin-top: 110px !important;
//     overflow: hidden;
// }


.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }

  // td{
  // 	display: inline-block;
  // 	width: 170px !important;
  // }
}

::v-deep tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    >span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -50px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
